// In-memory reuse avoids remount flashes. Firebase is the persistent source;
// this cache never grants database access or writes an access decision.
const decisions = new Map(), requests = new Map(), dismissed = new Map();
export const accessScope = profile => JSON.stringify([...new Set(profile?.assignedPapers || [])].sort());
export const accessKey = (uid, scope) => `${uid}:${scope}`;
export function cachedAccess(key) {
    const value = decisions.get(key);
    return value && value.data.validUntilMs > Date.now() + value.offset ? value : null;
}
export function rememberAccess(key, data, serverResponse = false) {
    const previous = decisions.get(key);
    const offset = serverResponse && Number.isFinite(data.serverNow) ? data.serverNow - Date.now() : previous?.offset || 0;
    const value = {data,offset};decisions.set(key,value);return value;
}
export const forgetAccess = key => decisions.delete(key);
export const reminderDismissed = (uid, day) => Boolean(day && dismissed.get(uid) === day);
export const dismissAccessReminder = (uid, day) => dismissed.set(uid,day);
export function requestAccess(key, force, request) {
    const running=requests.get(key);
    if(running && (!force || running.force))return running.promise;
    const promise=Promise.resolve().then(request).finally(()=>{if(requests.get(key)?.promise===promise)requests.delete(key);});
    requests.set(key,{force,promise});return promise;
}
export function clearExamAccessCache() {decisions.clear();requests.clear();dismissed.clear();}
